<template>
  <v-layout
    column
    wrap
  >
    <v-container
      grid-list-md
      fluid
      class="pa-2"
    >
      <transition
        :enter-active-class="transitionEnterClass"
        :leave-active-class="transitionLeaveClass"
        name="fade"
        mode="out-in"
      >
        <keep-alive include="InvitesTable">
          <router-view
            :key="$route.path"
          />
        </keep-alive>
      </transition>
    </v-container>
  </v-layout>
</template>

<script>
import pageTransitionMixin from '@/mixins/page-transition-mixin';

export default {
  name: 'Invites',
  mixins: [pageTransitionMixin],
  data() {
    return {};
  },
  beforeRouteUpdate(to, from, next) {
    this.updatePageTransition(to, from);
    next();
  },
  created() {
    this.$store.commit('setToolbarTitle', { toolbarTitle: 'Invites' });
  }
};
</script>
